import { render, staticRenderFns } from "./r-item-offer-dropdown.vue?vue&type=template&id=7e8e00ef"
import script from "./r-item-offer-dropdown.vue?vue&type=script&lang=js"
export * from "./r-item-offer-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e8e00ef')) {
      api.createRecord('7e8e00ef', component.options)
    } else {
      api.reload('7e8e00ef', component.options)
    }
    module.hot.accept("./r-item-offer-dropdown.vue?vue&type=template&id=7e8e00ef", function () {
      api.rerender('7e8e00ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item-offer/r-item-offer-dropdown.vue"
export default component.exports